import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/misc/logo-small.png';
class Menu extends Component {
  render() {
    return (
      <Fragment>
        {/* Logo */}
        <Link className='navbar-brand' to='/'>
          {' '}
          <img src={logo} alt='logo' />{' '}
        </Link>
        {/* Menu */}
        <ul className='navbar-nav'>
          <li className='menu-item menu-item-has-children'>
            <Link to='/'>Home</Link>{' '}
          </li>
          <li className='menu-item menu-item-has-children'>
            <Link to='/listings'>Listings</Link>{' '}
          </li>
          <li className='menu-item menu-item-has-children'>
            <Link to='/agents'>Agents</Link>{' '}
          </li>
          <li className='menu-item menu-item-has-children'>
            <Link to='/about'>About us</Link>
          </li>
          <li className='menu-item menu-item-has-children'>
            <Link to='/contact'>Contact Us</Link>
          </li>
        </ul>
      </Fragment>
    );
  }
}

export default Menu;
